// projects/humanresources-personnel/src/assets/i18n/*/hr-per-syndicate.json
export class HrPerSyndicateKey {
    private static readonly keyPrefix = 'hrPerSyndicate';
    public static title = `${HrPerSyndicateKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerSyndicateKey.keyPrefix}.pageHeader`;
    public static def = `${HrPerSyndicateKey.keyPrefix}.def`;
    public static startDateMembership = `${HrPerSyndicateKey.keyPrefix}.startDateMembership`;
    public static endDateMembership = `${HrPerSyndicateKey.keyPrefix}.endDateMembership`;
    public static membershipNo = `${HrPerSyndicateKey.keyPrefix}.membershipNo`;
}
